<template>
  <Modal class="long-modal" width="800" v-model="show" :mask-closable="false" :loading="loading">
    <Spin v-if="showSpin" class="spin"></Spin>
    <div slot="header" class="modal-header">{{title}}<span>{{`${projectName}.${stockNumber}`}}</span></div>
    <Form :model="formData" :label-width="82"  :rules="formRules" ref="formData">
      <Row :gutter="16">
        <Col span="7">
          <FormItem label="手机号">
            <Input :disabled="true" v-model="formData.phoneNum"></Input>
            <!-- <div v-show="phoneNumErr"  class="ivu-form-item-error-tip">输入正确的联系方式</div> -->
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="7" >
          <FormItem label="姓名" prop="name">
            <Input v-model="formData.name" :disabled="true"></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <div class="flex">
             <FormItem label="证件信息" prop="certType" class="certType">
            <Select v-model="formData.certType" style="width: 80px" :disabled="isRead">
                <Option v-for="item in cardTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
          </FormItem>
          <FormItem label="" prop="certNum" class="certNum">
             <Input v-model="formData.certNum" style="width: 140px" :disabled="isRead"></Input>
          </FormItem>
          </div>
        </Col>
        <Col span="7">
          <FormItem label="性别" prop="sex">
            <RadioGroup v-model="formData.sex">
              <Radio v-for=" (item,i) in genderTypeList" :key="`gender${item.value}`" :label="item.value" :disabled="true">
                  <span>{{item.text}}</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="出生年月" prop="birthday">
            <DatePicker placeholder="yyyy-mm-dd"  :disabled="true" v-model="formData.birthday" type="date" style="width: 100%"></DatePicker>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem label="工作类型" prop="jobCode">
            <Select v-model="formData.jobCode" :disabled="true" style="width: 220px">
              <Option v-for="item in jobTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="国籍" prop="nationality">
            <Input v-model="formData.nationality" :disabled="true"></Input>
          </FormItem>
        </Col>
        </Row>
        <Row :gutter="16">
        <Col span="7">
          <FormItem label="婚姻状况" prop="marriage">
            <Select v-model="formData.marriage" :disabled="true" >
              <Option v-for="item in marryStatusList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <div class="ivu-form-item-required ivu-form-item ">
            <span style="width:82px;" class="inline-b ivu-form-item-label">证件照片</span>
            <div style="display:flex;">
              <div class="upload-wrap">
              <img class="imgwidth" v-if="formData.certPic1"  :src="formData.certPic1" @click="showImg(formData.certPic1)"/>
              <Upload v-if="!isRead"
                :action="baseUrl+'/file/uploadFile'"
                :on-success="handleSuccessF"
                :headers="{'Access-Token':token}"
                :show-upload-list="false"
                :format="['jpg','jpeg','png']"
                :on-format-error="handleFormatError"
              >
                <div v-if="!formData.certPic1" class="upload" :class="{error: !validateLicense1}">
                  <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
                  <p>点击上传图片</p>
                </div>
                <a v-if="!formData.certPic1 && !validateLicense1" class="error-color" href="javascript:;">请上传证件照</a>
                <a v-if="formData.certPic1 && !isRead" href="javascript:;">修改</a>
              </Upload>
              </div>
             <div class="upload-wrap">
              <img class="imgwidth" v-if="formData.certPic2"  :src="formData.certPic2" @click="showImg(formData.certPic2)"/>
              <Upload v-if="!isRead"
                :action="baseUrl+'/file/uploadFile'"
                :on-success="handleSuccessB"
                :headers="{'Access-Token':token}"
                :show-upload-list="false"
                :format="['jpg','jpeg','png']"
                :on-format-error="handleFormatError"
              >
                <div v-if="!formData.certPic2" class="upload" :class="{error: !validateLicense2}">
                  <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
                  <p>点击上传图片</p>
                </div>
                <a v-if="!formData.certPic2 && !validateLicense2" class="error-color" href="javascript:;">请上传证件照</a>
                <a v-if="formData.certPic2 && !isRead" href="javascript:;">修改</a>
              </Upload>
            </div>
            </div>
          </div>
      <Row :gutter="16">
        <Col span="7">
          <FormItem label="紧急联系人" prop="emergencyContact">
              <Input :disabled="true"  v-model="formData.emergencyContact" ></Input>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="关系" prop="relationshipCode">
            <Select v-model="formData.relationshipCode" :disabled="true" >
              <Option v-for="item in contractsRelList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>

          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="联系电话" prop="emcyCntPhone">
              <Input :disabled="true"  v-model="formData.emcyCntPhone" ></Input>
          </FormItem>
        </Col>
      </Row>
      <div style="height:48px;">
        <span v-if="!(!hasRoomate && isRead)" class="inline-b ivu-form-item-label title">合住人</span>
        <a v-if="!hasRoomate && !isRead" href="javascript:;" class="inline-b ivu-form-item-label" style="width:82px; color:#CFA868" @click="addRoomate">添加+</a>
      </div>
      </Form>
      <div v-if="hasRoomate">
        <Form :model="sharerForm" :label-width="82"  :rules="sharerRules" ref="sharerForm">
       <Row :gutter="16">
        <Col span="12" >
          <FormItem label="姓名" prop="name">
            <Input v-model="sharerForm.name" :disabled="isRead"></Input>
          </FormItem>
        </Col>
         <Col span="10" >
          <FormItem label="手机号" prop="mobile">
            <Input v-model="sharerForm.mobile" :disabled="isRead"></Input>
          </FormItem>
        </Col>
       </Row>
       <Row :gutter="16">
         <Col span="12" >
          <div class="flex">
             <FormItem label="证件号" prop="certType" class="certType">
            <Select v-model="sharerForm.certType" style="width: 80px" :disabled="isRead">
                <Option v-for="item in cardTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
          </FormItem>
          <FormItem label="" prop="certNum" class="certNum">
             <Input v-model="sharerForm.certNum" style="width: 200px" :disabled="isRead"></Input>
          </FormItem>
          </div>
        </Col>
       <Col span="10" v-if="isRead">
           <FormItem label="添加日期" prop="addSharerTime">
               <Input v-model="sharerForm.addSharerTime" :disabled="true"></Input>
           </FormItem>
       </Col>
       <Col span="2" v-if="!isRead">
         <Icon class="delete-icon" size="18" color="#F56356" type="android-remove-circle" @click.native="openDelConfirmModal"></Icon>
        </Col>
      </Row>
         </Form>
      </div>
       <div v-if="isRead">
        <span class="inline-b ivu-form-item-label">历史租客</span>
        <table-list
          :columns="columns"
          :data="renterList"
          :showPage="false"
          :loading="tableLoading"
        >
        </table-list>
      </div>
      <cancel-modal :n = "delKey" @cancel="delSharer" :action="'删除'"></cancel-modal>
    <div slot="footer">
      <Button type="text" size="large" @click="close">取消</Button>
      <Button type="primary" size="large" @click="save" :loading="loading" v-if="!isRead">
        <span v-if="!loading" >保存</span>
        <span v-else>保存中...</span>
      </Button>
     <!-- <div v-if="hasRoomate && !sharerCount">
      </div>-->
    </div>
  </Modal>
</template>
<script type="text/ecmascript-6">
import { getBaseUrl } from "@/utils/public";
import { getToken } from "@/utils/auth";
import { addCondition, checkinPersion, addSharer, delSharer,getHistory } from "api/occupancy";
import CancelModal from 'components/CancelModal/index';
import TableList from 'components/TableList/index';
import {formatDateTime} from "@//utils/format"
export default {
  props: {
    n: {
      type: Number,
      default: 0
    },
    isRead: {
      type: Boolean,
      default: true
    },
    projectName: {
      type: String,
      default: "项目名"
    },
    stockNumber: {
      type: String,
      default: "101"
    },
    contractId:{
      type:String,
      default:''
    }
  },
  components: {
    CancelModal,
    TableList
  },
  created() {
    // this.getProjectConfigInfo()
    this.baseUrl = getBaseUrl();
    this.token = getToken();
    this.initData()
  },
  watch: {
    n(val) {

      this.checkinPersion()
      if(this.isRead){
        getHistory(this.contractId).then( res => {
          this.renterList = res.data.rows
          this.tableLoading = false
        })
      }
      this.loading = false;
      this.show = true;
      // this.$refs["formData"].resetFields();
    }
  },
  data() {
    const validatPhone = (rule, value, callback) => {
      let pattern = /^1\d{10}$/;
      if (!pattern.test(value)) {
        callback(new Error("输入正确的联系方式"));
      }
      callback();
    };
    const validateNum = (rule, value, callback) => {
      let pattern = /^\d+(\d|X)$/;
      if (!pattern.test(value)) {
        callback(new Error("请填写证件信息"));
      }
      callback();
    };
    return {
      showSpin:true,
      delKey:0,
      sharerCount:0,
      baseUrl: "",
      token: "",
      loading: false,
      show: false,
      cardTypeList: [],
      jobTypeList: [],
      genderTypeList:[],
      marryStatusList: [],
      contractsRelList:[],
      hasRoomate: false,
      sharerFid:'',
      validateLicense1:true,
      validateLicense2:true,
      formData: {
        contractId:'',
        phoneNum:'',
        name: '',
        certType: '',
        certNum: '',
        sex: '',
        birthday: '',
        birthdayYear:'',
        birthdayMonday:'',
        jobCode: '',
        nationality: '',
        certPic1: '',
        certPic2: '',
        marriage: '',
        emergencyContact: '',
        relationshipCode: '',
        emcyCntPhone: '',
        sharerVos:[]
      },
      formRules: {
        certType:[{required: true,message: "请选择证件类型",type: "number",trigger: "blur"}],
        certNum: [{required: true,validator:validateNum,type: "string",trigger: "blur"}]
      },
      sharerForm:{
        name: '',
        mobile: '',
        certType: '',
        certNum: '',
        addSharerTime: null,
      },
      sharerRules:{
        name: [{ required: true,message: "请输入姓名",type: "string",trigger: "blur"}],
        mobile: [{ required: true, validator: validatPhone, trigger: "blur" } ],
        certType:[{required: true,message: "请选择证件类型",type: "number",trigger: "blur"}],
        certNum: [{required: true,validator:validateNum,type: "string",trigger: "blur"}],
      },
      tableLoading:false,
      columns:[
        {
          title: '入住人',
          align: 'center',
          key: 'name'
        },
        {
          title: '手机号',
          align: 'center',
          key: 'phoneNum'
        },
        {
          title: '合住人',
          align: 'center',
          key: 'sharers',
          render: (h,params) => {
            let sharersArr = params.row.sharerEntities.map( item => {
              return item.name
            })
            let sharersStr = sharersArr.join(',')
            return h('span',sharersStr)
          }
        },
        {
          title: '变更时间',
          align: 'center',
          key: 'updateTime',
          render: (h,params) => {
            return h('div',formatDateTime(params.row.updateTime, true))
          }
        }

      ],
      renterList:[]
    };
  },
  computed: {
    title(){
      return this.isRead ? '查看入住人':'修改入住人'
    }

  },
  methods: {
    addRoomate() {
      this.hasRoomate = true;
    },
    close() {
      this.show = false;
    },
    checkinPersion(){
       this.showSpin = true
      checkinPersion(this.contractId).then( res => {

        this.formData = res.data
        this.sharerCount = res.data.sharerVos.length
        if(res.data.sharerVos.length) {
          this.hasRoomate = true
          this.sharerForm.name = res.data.sharerVos[0].sharerName
          this.sharerForm.certType = +res.data.sharerVos[0].sharerCertType
          this.sharerForm.certNum = res.data.sharerVos[0].sharerCertNum
          this.sharerForm.mobile = res.data.sharerVos[0].sharerPhone
          this.sharerForm.addSharerTime = res.data.sharerVos[0].addSharerTime
          this.sharerFid = res.data.sharerVos[0].fid
        }else {
          this.hasRoomate = false
          for( let key in  this.sharerForm){
            this.sharerForm[key] = ''
          }
        }
        this.showSpin = false
      }).catch( () => {
        this.showSpin = false
      })
    },
    delSharer(){
      let data = {
        fid:this.sharerFid
      }
      delSharer(data).then( res => {
        this.hasRoomate = false;
        this.$Message.success("删除成功");
        this.show =false
       })
       this.formData.sharerVos.length = 0
    },
    openDelConfirmModal() {
      // 是否有合住人
      if(this.sharerCount){
        this.delKey++
      } else {
        this.hasRoomate = false
      }
    },
    initData() {
      addCondition().then(res => {
        this.cardTypeList = res.data.cardType
        this.jobTypeList = res.data.jobType
        this.genderTypeList = res.data.genderType
        this.marryStatusList = res.data.marryStatus
        this.contractsRelList = res.data.contractsRel
      });
    },
    handleSuccessF(response) {
      this.formData.certPic1 = response.data.url;
      this.validateLicense1 = true
    },
    handleSuccessB(response) {
      this.formData.certPic2 = response.data.url;
      this.validateLicense2 = true
    },
    handleFormatError() {
      this.$Message.error("请输入jpg,jpeg,png,格式的文件");
    },
    validateSharerForm(){
      let result = true
      if(this.hasRoomate) {
        this.$refs['sharerForm'].validate(bool => {
            result = bool && result;
        })
      }
      return result
    },
    save() {
     // 添加合住人
      this.$refs['formData'].validate(bool => {
        let validateSharerForm = this.validateSharerForm()
        if(bool  && validateSharerForm) {
          let sharerAddDtos = []
          let data = null
          if(this.hasRoomate){
            sharerAddDtos.push(this.sharerForm)
          } else {
            sharerAddDtos.length = 0
          }
          console.info(this.formData)
          this.formData.contractId = this.contractId
          data = Object.assign({},{checkinAddDto:this.formData},{sharerAddDtos:sharerAddDtos})
          // console.log(data)
          addSharer(data).then( res => {
             this.$Message.success("添加成功！");
             this.$emit('refresh')
             this.show = false
          })
        }
      })
    },
    showImg(img) {
      this.$emit("show-img", img);
    },
  }
};
</script>
<style scoped>
a {
  color: #cfa868;
}

img {
  vertical-align: middle;
}
.w-80 {
  width: 100px;
  margin-left: 8px;
  vertical-align: middle;
}
.icon{
    font-size: 18px;
    vertical-align:bottom;
    padding-left: 8px;
}
.delete-icon{
      padding-left: 0px;
}
 .imgwidth {
  width: 167px;
  height: 118px;
}
a {
  color: #CFA868;
}

.upload-wrap {
  display: inline-block;
  line-height: 1;
  padding: 10px 4px;
}
.upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;

  }
  .ivu-upload {
    position: relative;

  }

  .ivu-upload  a {
    position :relative;
    right: 0;
    bottom: -55px;
  }
  .upload.error {
    border-color:#F56356;
  }
  a.error-color {
    color:#F56356;
    bottom: -18px;

  }
  .flex {
    display: flex;
  }
  .title {
    font-size: 14px;
    font-weight: 600;
     margin-bottom: 0px;
  }


</style>

